import React from "react"
import Page from "../components/page";


const MethodologyPage = (props) => {
  const pageTitle="College Basketball Rating Methodology | How Expected Margins Are Calculated";
  const seoDescription="Learn how cbbratings.com calculates NCAA men's college basketball ratings, converting team strength into expected winning margins using margin-of-victory modeling and home-court advantage.";
  const pageHeading="How the Rating System Works"
  const subHeading="Converting team strength into expected winning margins"
  return (
    <Page
      location={props.location.href}
      pageTitle={pageTitle}
      seoDescription={seoDescription}
      pageHeading={pageHeading}
      subHeading={subHeading}
    >
    <h2>Welcome</h2>
    <p>
      CBB Ratings provides an objective, statistical analysis of NCAA men's college basketball team strength, designed to translate directly into expected point margins.
      <br/>
      The goal is to offer a clear, intuitive measure of team quality based solely on game results.
    </p>

    <h2>Overview</h2>
    <p>
      Each team's rating is determined entirely by the scores of games played to date. Wins against stronger opponents improve a team's rating more than wins against weaker ones.
      <br/>
      Unlike traditional rankings, the system incorporates margin of victory to better capture relative performance.
    </p>

    <h2>Home Advantage</h2>
    <p>
      The model explicitly accounts for home-court advantage, which is estimated from historical game results and incorporated directly into rating calculations.
    </p>

    <h2>Updates</h2>
    <p>
      Ratings are updated daily during the season to reflect the most recent game outcomes.
    </p>
    </Page>
    );
};
export default MethodologyPage;